import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Trophy } from 'lucide-react';
import type { EvaluationResult } from './types';

interface ScorecardProps {
  evaluation: EvaluationResult;
  judgeModel: string;
}

export const Scorecard = ({ evaluation, judgeModel }: ScorecardProps) => {
  const ranked = [...evaluation.scorecard].sort((a, b) => b.weighted_total - a.weighted_total);

  return (
    <div className="space-y-4">
      <p className="text-muted-foreground text-xs">Metið af {judgeModel}</p>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Líkan</TableHead>
            <TableHead>Nákvæmni</TableHead>
            <TableHead>Heildstæði</TableHead>
            <TableHead>Fylgni við fyrirmæli</TableHead>
            <TableHead>Engin endurtekning</TableHead>
            <TableHead>Skýrleiki</TableHead>
            <TableHead>Málfar</TableHead>
            <TableHead>Samtals</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ranked.map((entry, index) => (
            <TableRow key={entry.model}>
              <TableCell className="flex items-center gap-2 font-medium">
                {index === 0 && <Trophy className="h-4 w-4 text-amber-500" />}
                {entry.model}
              </TableCell>
              <TableCell>{entry.scores.accuracy}</TableCell>
              <TableCell>{entry.scores.completeness}</TableCell>
              <TableCell>{entry.scores.instruction_following}</TableCell>
              <TableCell>{entry.scores.no_duplication}</TableCell>
              <TableCell>{entry.scores.clarity}</TableCell>
              <TableCell>{entry.scores.language_quality}</TableCell>
              <TableCell>
                <Badge variant={index === 0 ? 'default' : 'secondary'}>{entry.weighted_total.toFixed(2)}</Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Samantekt matsins</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <p>{evaluation.comparison.summary}</p>
          <p className="text-muted-foreground text-xs">
            Best: {evaluation.comparison.best_model} · Verst: {evaluation.comparison.worst_model}
          </p>
        </CardContent>
      </Card>

      <div className="grid gap-3 md:grid-cols-2">
        {ranked.map((entry) => (
          <Card key={entry.model}>
            <CardHeader>
              <CardTitle className="text-base">{entry.model}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm">
              {evaluation.detailed_feedback[entry.model] && <p>{evaluation.detailed_feedback[entry.model]}</p>}
              {entry.key_issues.length > 0 && (
                <ul className="list-disc space-y-1 pl-4 text-muted-foreground text-xs">
                  {entry.key_issues.map((issue) => (
                    <li key={issue}>{issue}</li>
                  ))}
                </ul>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
